import { Container, Spinner } from 'react-bootstrap';

const ProjectPlaceholder = () => {

    return (
        <Container className="container-project-placeholder">
            <Spinner
                className="spinner-project-placeholder"
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
            />
        </Container>
    );
};

export default ProjectPlaceholder;
